import React, { useContext, useState, FunctionComponent } from 'react';
import { v4 as uuidv4 } from 'uuid';

import { PrimaryButton, SecondaryButton } from '@components/library/button';
import assetModalContext from '@components/asset/modal/tabs/edit/asset_modal_context';
import {
  ActionTypes,
  CustomFieldPayloadOperations,
  FlattenedCustomFieldKeyValuesMap,
  UpdateCustomFieldValuesDispatch,
} from '@components/asset/modal/tabs/edit/EditTabTypes';
import PrimaryInput from '@components/library/inputs/PrimaryInput';

interface AddUncontrolledCustomFieldButtonProps {
  setNewCustomFieldFocus: SetStateDispatch<boolean>;
}

interface AddCustomFieldScopedContext {
  state: {
    editState: {
      flattenedCustomFieldKeyValuesMap: FlattenedCustomFieldKeyValuesMap;
    };
  };
  dispatch: UpdateCustomFieldValuesDispatch;
}

export const AddUncontrolledCustomFieldButton: FunctionComponent<AddUncontrolledCustomFieldButtonProps> = ({
  setNewCustomFieldFocus
}) => {
  const { dispatch }: AddCustomFieldScopedContext = useContext(assetModalContext);
  const [editMode, setEditMode] = useState(false);
  const [keyName, setKeyName] = useState('');
  const [valueName, setValueName] = useState('');

  const addCustomFieldRow = (): void => {
    const keyId = `create-cfk-${uuidv4()}`;
    dispatch({
      type: ActionTypes.UpdateCustomFieldValues,
      payload: {
        operation: CustomFieldPayloadOperations.Create,
        customFieldKeyId: keyId,
        customFieldKeyName: keyName,
        customFieldValue: { key: '', value: valueName }
      }
    });
  };

  const resetForm = (): void => {
    setEditMode(false);
    setKeyName('');
    setValueName('');
  };

  return (
    <div className="add-custom-field-form custom-field-row custom-field-row__new">
      {editMode ? (
        <>
          <span className="custom-field-key--container">
            <PrimaryInput
              attributes={{
                'aria-label': "Custom Field Key",
                className: "custom-field-primary-input",
                name: `custom-field-input--new-field`,
                onChange: (e): void => {
                  setKeyName((e as InputChangeEvent).target.value);
                },
                placeholder: bfTranslate('Key'),
                value: keyName
              }}
              input={{ value: keyName }}
            />
          </span>
          <div className="custom-field-value--container">
            <PrimaryInput
              attributes={{
                'aria-label': "custom field value",
                className: "custom-field-primary-input",
                name: `custom-field-value-input--new-field`,
                placeholder: bfTranslate("Input value"),
                value: valueName,
                onChange: (e): void => {
                  setValueName((e as InputChangeEvent).target.value);
                }
              }}
              input={{ value: valueName }}
            />
          </div>
          <PrimaryButton
            onClick={(): void => {
              addCustomFieldRow();
              resetForm();
            }}
          >
            {bfTranslate('Add Custom Field')}
          </PrimaryButton>
        </>
      ) : (
        <SecondaryButton
          icon="bff-plus"
          onClick={(): void => {
            addCustomFieldRow();
            setNewCustomFieldFocus(true);
          }}
        >
          {bfTranslate('Add Custom Field')}
        </SecondaryButton>
      )}
    </div>
  );
};
